import { ICourseModulesNodes } from '@dtos/Course'
import { IEnrollment } from '@dtos/Enrollment'

interface IIsLastLessonOfPreviousModuleCompletedProps {
  modules: ICourseModulesNodes[]
  index: number
  enrollment: IEnrollment | null | undefined
}

export function isLastLessonOfPreviousModuleCompleted({
  modules,
  index,
  enrollment,
}: IIsLastLessonOfPreviousModuleCompletedProps): boolean {
  if (index === 0) return true

  const previousModule =
    modules[index - 1].courseModules?.length > 0
      ? modules[index - 1].courseModules[
          modules[index - 1].courseModules.length - 1
        ]
      : modules[index - 1]

  const previousModuleLastLesson =
    previousModule.courseContents.nodes[
      previousModule.courseContents.nodes.length - 1
    ]

  return !!enrollment?.progressCard?.lessonsProgresses?.find(
    (lesson) => lesson.lessonId === previousModuleLastLesson?.lesson.id,
  )?.completed
}
